export const ServiceCardKindEnum = Object.freeze({
    SIMPLE: 'SIMPLE',
    EXTENDED: 'EXTENDED',
});
